export enum PropertySources {
  QUOTE = 'Quote',
  ESTIMATE = 'Estimate',
}
